// Module
var code = "<div ref=\"colorPickerContainer\">\n    <div ref=\"colorsContainer\"></div>\n    <div ref=\"colorPickerRecentContainer\">\n        <div class=\"recent-color-title\"> Recent colors</div>\n        <div ref=\"colorPickerRecentColorsContainer\"></div>\n    </div>\n</div>";
// Exports
module.exports = code;